module.exports = __webpack_public_path__ + "img/icon-cart-black.91655602.svg";